"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MULTICALL_HANDLER_ADDRESS = exports.SPOKE_POOL_ADDRESS = void 0;
const context_1 = require("@derivation-tech/context");
exports.SPOKE_POOL_ADDRESS = {
    [context_1.CHAIN_ID.ETHEREUM]: '0x5c7BCd6E7De5423a257D81B442095A1a6ced35C5',
    [context_1.CHAIN_ID.OPTIMISM]: '0x6f26Bf09B1C792e3228e5467807a900A503c0281',
    [context_1.CHAIN_ID.POLYGON]: '0x9295ee1d8C5b022Be115A2AD3c30C72E34e7F096',
    [context_1.CHAIN_ID.ZKSYNC]: '0xE0B015E54d54fc84a6cB9B666099c46adE9335FF',
    [context_1.CHAIN_ID.ARBITRUM]: '0xe35e9842fceaCA96570B734083f4a58e8F7C5f2A',
    [context_1.CHAIN_ID.BASE]: '0x09aea4b2242abC8bb4BB78D537A67a245A7bEC64',
    [context_1.CHAIN_ID.LINEA]: '0x7E63A5f1a8F0B4d0934B2f2327DAED3F6bb2ee75',
    [context_1.CHAIN_ID.BLAST]: '0x2D509190Ed0172ba588407D4c2df918F955Cc6E1',
    [context_1.CHAIN_ID.SCROLL]: '0x3baD7AD0728f9917d1Bf08af5782dCbD516cDd96',
};
exports.MULTICALL_HANDLER_ADDRESS = {
    [context_1.CHAIN_ID.ETHEREUM]: '0x924a9f036260DdD5808007E1AA95f08eD08aA569',
    [context_1.CHAIN_ID.OPTIMISM]: '0x924a9f036260DdD5808007E1AA95f08eD08aA569',
    [context_1.CHAIN_ID.POLYGON]: '0x924a9f036260DdD5808007E1AA95f08eD08aA569',
    [context_1.CHAIN_ID.ZKSYNC]: '0x863859ef502F0Ee9676626ED5B418037252eFeb2',
    [context_1.CHAIN_ID.ARBITRUM]: '0x924a9f036260DdD5808007E1AA95f08eD08aA569',
    [context_1.CHAIN_ID.BASE]: '0x924a9f036260DdD5808007E1AA95f08eD08aA569',
    [context_1.CHAIN_ID.LINEA]: '0x1015c58894961F4F7Dd7D68ba033e28Ed3ee1cDB',
    [context_1.CHAIN_ID.BLAST]: '0x924a9f036260DdD5808007E1AA95f08eD08aA569',
    [context_1.CHAIN_ID.SCROLL]: '0x924a9f036260DdD5808007E1AA95f08eD08aA569',
};
